/**
 * When using XdMessaging/postMessage this can be used to get the ParentId to send along with any data as
 * intendedReceiver.
 *
 * @param {string} url
 * @returns {string}
 */
export function getParentIdFromUrl(url) {
  const currentUrl = new URL(url)
  return currentUrl.searchParams.get('parent_id')
}
